import { getApiBase } from "./apiBase";
import { dropSession, isAuthError } from "./session";

const authHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const postJson = async (path, body = {}) => {
  const base = getApiBase();
  if (!base) {
    throw new Error("не задан адрес API");
  }

  const res = await fetch(`${base}${path}`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));

  if (isAuthError(res.status, data && data.message)) {
    dropSession();
    const error = new Error("сессия истекла, войдите заново");
    error.status = res.status;
    throw error;
  }

  if (!res.ok) {
    const payload = data && data.data && typeof data.data === "object" ? data.data : data;
    const fieldError = Object.keys(payload || {})
      .filter((k) => Array.isArray(payload[k]) && payload[k].length)
      .map((k) => payload[k][0])[0];
    const error = new Error(
      fieldError || data.message || data.error || `код ${res.status}`
    );
    error.status = res.status;
    error.payload = payload;
    throw error;
  }

  return data;
};

/** Баланс grant 757 и локации пользователя. */
export const fetchGrantExtendInfo = () => postJson("/v1/cpai/grant-extend-info", {});

/** Продлить локацию на N месяцев (1 награда = 1 месяц). */
export const extendLocationWithGrants = (locationId, months) =>
  postJson("/v1/cpai/grant-extend", {
    location_id: Number(locationId),
    months: Number(months),
  });
